import API from "../../Network/API";
import React, { useEffect, useRef, useState } from "react";
import ContentLoader from "react-content-loader";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import UserChatFile from "./UserChatFile";
import MessageNav from "./MessageNav";
import FileSend from "./FileSend";
import { useDispatch, useSelector } from "react-redux";
import {
    ADD_MESSAGE_SUCCESS,
    INBOX_FETCH_SUCCESS,
    DELETE_TEMP_MESSAGE,
    DELETE_MESSAGE,
    RECEIVE_MESSAGE_LOADING
} from "../../Reducer/userInboxReducer";
import { MESSAGE_FETCH_ECHO } from '../../Reducer/messageReducer';
import CallSendPopup from '../../Props/CallSendPopup';
import NewCallSound from '../../assets/audio/NewCall.mp3';
import { ADD_CHATID_SUCCESS } from "../../Reducer/ChatListId";
import { USER_SELF_FETCH_SUCCESS } from "../../Reducer/UserSelfReducer";
import useTimer from "../../CustomHooks/useTimer";
import { formatTime } from '../../utils';
import ChatBg from '../../assets/img/web_chat_bg.png';
import ImageView from "../Modal/ImageView";
import "./UserInboxModern.css";

const mimeType = "audio/webm";

const UserInbox = () => {
    const [demo_data] = useState([{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }]);
    const [progress, setProgress] = useState(false);
    const [selfId, setSelfId] = useState(null);
    const [data_read, setData_read] = useState(false);
    const [text, setText] = useState("");
    const [user, setUser] = useState("");
    const messagesEndRef = useRef(null);
    const textData = useRef();
    const [chatHistory, setChatHistory] = useState([]);
    const [isLoading, setLoading] = useState(false);

    const self_data = JSON.parse(localStorage.getItem("user_data"));
    let { id } = useParams();
    const [post_modalDialog, setPostShareModalDialog] = useState(false);
    const [page, setPage] = useState(0);
    const [has_page, setHasPage] = useState(false);

    const [callStart, setCallStart] = useState(false);

    const [reply_message_enable, setReplyMessageEnable] = useState(false);
    const [reply_message_id, setReplyMessageId] = useState(0);
    const [reply_message, setReplyMessage] = useState(null);
    const [reply_to, setReplyTo] = useState(null);

    const [is_darg_drop, setIsDragDrop] = useState(false);
    const [darg_drop_file, setDragDrop] = useState(null);
    const [dragActive, setDragActive] = useState(false);
    const dragCounter = useRef(0);

    const [isExpand, setIsExpand] = useState(true);

    const audioRef = useRef(new Audio(NewCallSound));

    // Voice recording
    const mediaRecorder = useRef(null);
    const discardRecording = useRef(false);
    const [recordingStatus, setRecordingStatus] = useState(false);
    const [audioChunks, setAudioChunks] = useState([]);
    const { timer, handleStart, handleReset } = useTimer(0);

    // Image viewer
    const [img_index, setImIndex] = useState(null);
    const [imageView_modalDialog, setImageViewModalDialog] = useState(false);
    const [image_array, setImageArray] = useState([]);

    const dispatch = useDispatch();
    const chatReducer = useSelector((state) => state.chatLogs);
    const chats = chatReducer?.messsage;

    // Listen for call state changes from Realtime.js WebSocket events
    useEffect(() => {
        const stopRinging = () => {
            setCallStart(false);
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
        };
        window.addEventListener('call-accepted', stopRinging);
        window.addEventListener('call-rejected', stopRinging);
        return () => {
            window.removeEventListener('call-accepted', stopRinging);
            window.removeEventListener('call-rejected', stopRinging);
        };
    }, []);

    useEffect(() => {
        dispatch(USER_SELF_FETCH_SUCCESS(JSON.parse(localStorage.getItem("user_data"))));
        dispatch(ADD_CHATID_SUCCESS(id));
    }, [id]);

    useEffect(() => {
        setProgress(true);
        API.get(`/users/${id}/conversation`).then(response => {
            setHasPage(response.data.data.message_pagination.next_page_url != null);
            setSelfId(response.data.data.self);

            const ttt = response.data.data.conversations.slice().reverse();
            const tt = ttt[ttt?.length - 1];
            if (tt != null) {
                const fromPartner = id == tt.sender.id;
                dispatch(MESSAGE_FETCH_ECHO({
                    last_message_id: tt.id,
                    name: fromPartner ? tt.sender.name : tt.receiver.name,
                    image: fromPartner ? tt.sender.avatar : tt.receiver.avatar,
                    to_id: fromPartner ? tt.from_id : tt.to_id,
                    is_group: tt.is_group,
                    message: tt.message,
                    url_details: tt.url_details,
                    seen_at: tt.is_seen ? tt.seen_at : null,
                    last_messages: null,
                    is_online: fromPartner ? tt.sender.is_online : tt.receiver.is_online,
                    unread_count: 0,
                    created_at: tt.created_at,
                }));
            }

            setData_read(true);
            setUser(response.data.data.user);
            setProgress(false);
            dispatch(INBOX_FETCH_SUCCESS(response.data.data));
            setPage(2);

            setTimeout(() => scrollToBottomImmediate(), 200);
        });

        API.get(`/friend_file_sharing/${id}`).then(response => {
            setChatHistory(response.data.data.conversations);
        });
    }, [id]);

    // ── Typing indicator ──────────────────────────────────────────────────
    // Whispers (Pusher client events) on a shared per-conversation channel
    // Chat.{min}.{max} — relayed by Soketi directly between subscribers,
    // the backend is only involved in channel auth.
    const [partnerTyping, setPartnerTyping] = useState(false);
    const typingClearTimer = useRef(null);
    const lastTypingSentAt = useRef(0);
    const typingChannelName = useRef(null);

    useEffect(() => {
        if (!id || !self_data?.id || !window.Echo) return;
        const a = Number(id), b = Number(self_data.id);
        if (!a || !b || a === b) return;
        const channelName = `Chat.${Math.min(a, b)}.${Math.max(a, b)}`;
        typingChannelName.current = channelName;

        window.Echo.private(channelName).listenForWhisper('typing', (e) => {
            if (String(e.from_id) !== String(id)) return;
            setPartnerTyping(true);
            // Self-clearing: whispers are fire-and-forget, so hide the
            // indicator when they stop arriving instead of relying on an
            // explicit "stopped" event.
            clearTimeout(typingClearTimer.current);
            typingClearTimer.current = setTimeout(() => setPartnerTyping(false), 4000);
        });

        return () => {
            clearTimeout(typingClearTimer.current);
            setPartnerTyping(false);
            typingChannelName.current = null;
            window.Echo.leave(channelName);
        };
    }, [id]);

    const sendTypingWhisper = () => {
        // Throttled: at most one whisper per 2.5s while keys are pressed.
        if (!typingChannelName.current || !window.Echo) return;
        const now = Date.now();
        if (now - lastTypingSentAt.current < 2500) return;
        lastTypingSentAt.current = now;
        window.Echo.private(typingChannelName.current)
            .whisper('typing', { from_id: self_data?.id });
    };

    // ── Scrolling ─────────────────────────────────────────────────────────
    const messagesBoxRef = useRef(null);
    const loadingOlder = useRef(false);
    const prevScrollHeight = useRef(0);
    // When the server confirms a sent message, the optimistic temp bubble is
    // swapped for the real one (new React key → remount). Remember the real id
    // so the swap doesn't replay the entry animation and visually "jump".
    const justConfirmedId = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
    };

    const scrollToBottomImmediate = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "auto", block: "end" });
    };

    const isNearBottom = () => {
        const el = messagesBoxRef.current;
        if (!el) return true;
        return el.scrollHeight - el.scrollTop - el.clientHeight < 220;
    };

    useEffect(() => {
        if (loadingOlder.current) return; // keep reading position on "load older"
        if (chats && chats.length > 0 && !progress && isNearBottom()) {
            setTimeout(() => scrollToBottomImmediate(), 100);
        }
    }, [chats, progress]);

    useEffect(() => {
        if (id && !progress) {
            setTimeout(() => scrollToBottomImmediate(), 300);
        }
    }, [id]);

    // ── Sending ───────────────────────────────────────────────────────────
    const sendMessage = () => {
        if (!text || text.trim() === "") {
            return;
        }
        if (!selfId) return;

        const fd = new FormData();

        dispatch(ADD_MESSAGE_SUCCESS({
            temp_id: id,
            from_id: selfId.id,
            to_id: id,
            seen_at: null,
            message: text,
            is_reply: reply_message_enable ? 1 : 0,
            old_message: reply_message_enable ? reply_message : null,
            sender: { name: selfId.name, avatar: selfId.avatar },
            created_at: "1s ago"
        }));

        fd.append('to_id', id);
        fd.append('message', text);
        if (reply_message_id != 0) {
            fd.append('reply_to', reply_message_id);
        }

        replyMessageCancel();
        setText("");
        resetTextareaHeight();
        scrollToBottom();
        setLoading(true);

        API.post("/send_chat", fd).then((response) => {
            setLoading(false);
            if (response.data.success === true) {
                const tt = response.data.data.message;
                dispatch(MESSAGE_FETCH_ECHO({
                    last_message_id: tt.id,
                    name: tt.receiver.name,
                    image: tt.receiver.avatar,
                    to_id: tt.to_id,
                    is_group: tt.is_group,
                    message: tt.message,
                    url_details: tt.url_details,
                    seen_at: null,
                    last_messages: null,
                    is_online: tt.receiver.is_online,
                    unread_count: 0,
                    created_at: tt.created_at,
                }));
                justConfirmedId.current = tt.id;
                dispatch(DELETE_TEMP_MESSAGE(id));
                dispatch(ADD_MESSAGE_SUCCESS(tt));
            }
        }).catch(() => {
            setLoading(false);
        });

        scrollToBottom();
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        sendMessage();
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            sendMessage();
        }
    };

    const handleInput = (e) => {
        const textarea = e.target;
        const maxHeight = 120;
        const minHeight = 38;
        textarea.style.height = "auto";
        if (e.target.value.trim() === "") {
            textarea.style.height = `${minHeight}px`;
            textarea.style.overflowY = "hidden";
        } else {
            const newHeight = Math.min(Math.max(textarea.scrollHeight, minHeight), maxHeight);
            textarea.style.height = `${newHeight}px`;
            textarea.style.overflowY = textarea.scrollHeight > maxHeight ? "auto" : "hidden";
        }
        setText(e.target.value);
        if (e.target.value.trim() !== "") {
            sendTypingWhisper();
        }
    };

    const resetTextareaHeight = () => {
        const textarea = textData.current;
        if (textarea) {
            textarea.style.height = "38px";
            textarea.style.overflowY = "hidden";
        }
    };

    // ── Message actions ───────────────────────────────────────────────────
    const deleteMessageEveryOne = (messageId) => {
        API.post(`conversations/${messageId}/delete`, { message_id: messageId }).then(() => {
            dispatch(DELETE_MESSAGE(messageId));
            toast.success('Message deleted');
        }).catch(() => { });
    };

    const deleteMessage = (messageId) => {
        API.post(`conversations/message/${messageId}/delete`, { message_id: messageId }).then(() => {
            dispatch(DELETE_MESSAGE(messageId));
            toast.success('Message deleted');
        }).catch(() => { });
    };

    const replyMessage = (msgId, message, username) => {
        setReplyMessageEnable(true);
        setReplyMessageId(msgId);
        setReplyMessage(message);
        setReplyTo(username);
        textData.current?.focus();
    };

    const replyMessageCancel = () => {
        setReplyMessageEnable(false);
        setReplyMessageId(0);
        setReplyMessage(null);
        setReplyTo(null);
    };

    // Infinite scroll: fetch older messages when the user scrolls near the top
    const handleMessagesScroll = () => {
        const el = messagesBoxRef.current;
        if (!el) return;
        if (el.scrollTop < 80 && has_page && !progress && !loadingOlder.current) {
            loadMore();
        }
    };

    // If the first page doesn't overflow the container there is nothing to
    // scroll, so keep fetching until it does (or pages run out).
    useEffect(() => {
        const el = messagesBoxRef.current;
        if (!el || progress || !has_page || !chats?.length) return;
        if (el.scrollHeight <= el.clientHeight) {
            loadMore();
        }
    }, [chats, progress, has_page]);

    function loadMore() {
        setProgress(true);
        loadingOlder.current = true;
        prevScrollHeight.current = messagesBoxRef.current?.scrollHeight ?? 0;
        API.get(`/users/${id}/conversation?page=${page}`).then(response => {
            setPage(page + 1);
            setHasPage(response.data.data.message_pagination.next_page_url != null);
            setProgress(false);
            dispatch(RECEIVE_MESSAGE_LOADING(response.data.data));
            // Restore the viewport to the message the user was looking at
            setTimeout(() => {
                const el = messagesBoxRef.current;
                if (el) el.scrollTop = el.scrollHeight - prevScrollHeight.current;
                loadingOlder.current = false;
            }, 80);
        }).catch(() => {
            setProgress(false);
            loadingOlder.current = false;
        });
    }

    const childToParent = (childdata) => {
        if (childdata?.id) justConfirmedId.current = childdata.id;
        dispatch(DELETE_TEMP_MESSAGE(id));
        dispatch(ADD_MESSAGE_SUCCESS(childdata));
        setTimeout(() => scrollToBottom(), 100);
    };

    // ── Calls ─────────────────────────────────────────────────────────────
    const playNewCall = () => audioRef.current.play();
    const pauseNewCall = () => audioRef.current.pause();

    function startCall(userId, type = '1', userName = '') {
        setCallStart(true);
        playNewCall();
        // Store call type and callee name for Realtime.js CallAccept handler
        window._outgoingCallType = type;
        window._outgoingCallName = userName;
        window._outgoingCallPromise = API.post(`send_calling?user_id=${userId}&type=${type}`).then((response) => {
            // Backend returns: { success, data, livekit_url, token, room_name }
            window._outgoingCallToken = response.data?.token;
            window._outgoingCallLivekitUrl = response.data?.livekit_url;
            window._outgoingCallId = response.data?.data?.id;
        }).catch((error) => {
            if (error?.response?.status === 403) {
                setCallStart(false);
                pauseNewCall();
                toast.info(error.response.data?.error || 'This user has disabled calls');
            }
            console.log(error);
        });

        // hide calling ui after 30 seconds
        setTimeout(() => setCallStart(false), 30000);
    }

    async function cancelCall() {
        setCallStart(false);
        pauseNewCall();
        if (window._outgoingCallPromise) {
            await window._outgoingCallPromise.catch(() => { });
        }
        const callingId = window._outgoingCallId;
        if (callingId) {
            API.post(`v1/calls/${callingId}/cancel`).catch(() => { });
        }
        window._outgoingCallId = null;
        window._outgoingCallToken = null;
        window._outgoingCallLivekitUrl = null;
        window._outgoingCallType = null;
        window._outgoingCallName = null;
        window._outgoingCallPromise = null;
    }

    // ── Voice recording ───────────────────────────────────────────────────
    const startRecording = async () => {
        if (!("MediaRecorder" in window)) {
            toast.error("Recording is not supported in your browser");
            return;
        }
        let mediaStream;
        try {
            mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
        } catch (err) {
            toast.error(err.message);
            return;
        }
        discardRecording.current = false;
        setRecordingStatus(true);
        handleStart();

        const media = new window.MediaRecorder(mediaStream, { type: mimeType });
        mediaRecorder.current = media;

        let localAudioChunks = [];
        media.ondataavailable = (event) => {
            if (typeof event.data === "undefined" || event.data.size === 0) return;
            localAudioChunks.push(event.data);
        };
        media.start();
        setAudioChunks(localAudioChunks);
    };

    const finishRecording = (discard) => {
        setRecordingStatus(false);
        handleReset();
        if (!mediaRecorder.current) return;
        discardRecording.current = discard;

        mediaRecorder.current.onstop = () => {
            const chunks = audioChunks;
            setAudioChunks([]);
            if (discardRecording.current || chunks.length === 0) return;

            const audioBlob = new Blob(chunks, { type: mimeType });
            let data = new FormData();
            data.append('to_id', id);
            data.append('message', '');
            data.append('files[]', audioBlob, "recording.wav");
            setLoading(true);
            API.post("/send_chat", data, {
                headers: { 'content-type': 'multipart/form-data' }
            }).then((response) => {
                setLoading(false);
                if (response.data.success === true && response.data.data?.message) {
                    dispatch(ADD_MESSAGE_SUCCESS(response.data.data.message));
                    setTimeout(() => scrollToBottom(), 100);
                }
            }).catch(() => setLoading(false));
        };

        mediaRecorder.current.stop();
        mediaRecorder.current.stream?.getTracks().forEach((track) => track.stop());
    };

    // ── Drag & drop ───────────────────────────────────────────────────────
    const hasFiles = (e) => e.dataTransfer && Array.from(e.dataTransfer.types || []).includes('Files');

    const handleDragEnter = (e) => {
        if (!hasFiles(e)) return;
        e.preventDefault();
        dragCounter.current += 1;
        setDragActive(true);
    };

    const handleDragLeave = (e) => {
        if (!hasFiles(e)) return;
        e.preventDefault();
        dragCounter.current -= 1;
        if (dragCounter.current <= 0) {
            dragCounter.current = 0;
            setDragActive(false);
        }
    };

    const handleDragOver = (e) => {
        if (hasFiles(e)) e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        dragCounter.current = 0;
        setDragActive(false);
        const dropped = e.dataTransfer.files?.[0];
        if (!dropped) return;
        setDragDrop(dropped);
        setIsDragDrop(true);
        setPostShareModalDialog(true);
    };

    const closeFileModal = () => {
        setPostShareModalDialog(false);
        setIsDragDrop(false);
        setDragDrop(null);
    };

    // ── Image viewer ──────────────────────────────────────────────────────
    const toggleImageView = (value, imgindex) => {
        setImageArray([value]);
        setImIndex(imgindex);
        setImageViewModalDialog(!imageView_modalDialog);
    };

    // ── Renderers ─────────────────────────────────────────────────────────
    const formatCallDuration = (s) => {
        if (s <= 0) return '0 sec';
        if (s < 60) return `${s} sec`;
        const m = Math.floor(s / 60);
        const r = s % 60;
        return r === 0 ? `${m} min` : `${m} min ${r} sec`;
    };

    // WhatsApp-style in-chat call summary (message_type 13). The call metadata
    // rides on url_details: url = call type ('1' video / '0' audio),
    // description = answered ('1'/'0'), title = talk duration in seconds.
    const renderCallBubble = (value, isMe) => {
        const details = value.url_details || {};
        const isVideo = details.url === '1';
        const answered = details.description === '1';
        const durationSec = parseInt(details.title, 10) || 0;
        const missed = !answered && !isMe;
        const color = missed ? '#ff5a5a' : (isMe ? '#ffffff' : '#222');
        const title = missed
            ? (isVideo ? 'Missed video call' : 'Missed voice call')
            : (isVideo ? 'Video call' : 'Voice call');
        const subtitle = answered
            ? formatCallDuration(durationSec)
            : (missed ? 'Tap to call back' : 'No answer');

        return (
            <div className="clickable d-flex align-items-center"
                onClick={() => startCall(user.id, isVideo ? '1' : '0', user.name)}>
                <div className="d-flex align-items-center justify-content-center"
                    style={{
                        width: 38, height: 38, borderRadius: '50%', flexShrink: 0,
                        background: missed ? 'rgba(255,90,90,0.15)'
                            : (isMe ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.08)')
                    }}>
                    <i className={`fa-solid ${isVideo ? 'fa-video' : 'fa-phone'}`}
                        style={{ color, fontSize: 16 }} />
                </div>
                <div className="ms-2">
                    <p className="mb-0" style={{ color, fontWeight: 600, fontSize: 14, lineHeight: 1.2 }}>{title}</p>
                    <span style={{ color, opacity: 0.8, fontSize: 11 }}>
                        <i className={`fa-solid ${isMe ? 'fa-arrow-up' : (missed ? 'fa-phone-slash' : 'fa-arrow-down')} me-1`} />
                        {subtitle}
                    </span>
                </div>
            </div>
        );
    };

    const renderTicks = (value) => {
        // Sending: single tick. Confirmed by server: double tick. Seen: colored double tick.
        if (value.temp_id) {
            return <i className="fa-solid fa-check uix-ticks uix-sending" />;
        }
        return <i className={`fa-solid fa-check-double uix-ticks ${value.is_seen != 0 ? 'uix-seen' : 'uix-sent'}`} />;
    };

    const renderMeta = (value, isMe) => (
        <span className="uix-meta">
            {value.created_at}
            {isMe && renderTicks(value)}
        </span>
    );

    const renderLinkCard = (details, isMe) => (
        <a className="uix-link-card" href={details.url} target="_blank" rel="noreferrer">
            {details.image && <img src={details.image} alt="" loading="lazy" />}
            <div className="uix-link-card-body">
                {details.title && <p className="uix-link-title">{details.title}</p>}
                {details.description && <p className="uix-link-desc">{details.description}</p>}
            </div>
        </a>
    );

    const renderBody = (value, isMe) => {
        // Call summary
        if (value.message_type == 13) {
            return (
                <>
                    {renderCallBubble(value, isMe)}
                    {renderMeta(value, isMe)}
                </>
            );
        }

        // File / media message
        if (value.file_name != null) {
            return (
                <>
                    {value.message_type == 4 ?
                        <audio className="uix-media-audio" controls src={value.file_name} />
                        : value.message_type == 5 ?
                            <video className="uix-media-video" controls src={value.file_name} />
                            :
                            <>
                                <img
                                    className="uix-media-img"
                                    src={value.file_name}
                                    alt=""
                                    loading="lazy"
                                    onClick={() => toggleImageView(value.file_name, 0)}
                                />
                                <a className="uix-download" target="_blank" rel="noreferrer" href={value.file_name}>
                                    <i className="fa-solid fa-download" /> Download
                                </a>
                            </>
                    }
                    {value.message ? <p dir="auto" className="uix-text uix-media-caption">{value.message}</p> : null}
                    {value.url_details != null && renderLinkCard(value.url_details, isMe)}
                    {renderMeta(value, isMe)}
                </>
            );
        }

        // Meeting invitation
        if (value.message_type === 10) {
            return (
                <>
                    <p className="uix-meeting-title">
                        <i className="fa-solid fa-video me-2" />
                        {isMe ? 'Meeting Link' : 'Invitation for Meeting'}
                    </p>
                    <p className="uix-meeting-link">{value.message}</p>
                    <a href={value.message} target="_blank" rel="noreferrer" className="uix-meeting-join">
                        <i className="fas fa-plus" /> Join Now
                    </a>
                    {renderMeta(value, isMe)}
                </>
            );
        }

        // Link message with preview
        if (value.message_type == 11 && value.url_details) {
            return (
                <>
                    {value.url_details.url && (
                        <a className="uix-link-url" href={value.url_details.url} target="_blank" rel="noreferrer">
                            {value.url_details.url}
                        </a>
                    )}
                    {renderLinkCard(value.url_details, isMe)}
                    {renderMeta(value, isMe)}
                </>
            );
        }

        // Plain text (optionally a reply, optionally with a URL preview)
        return (
            <>
                {value.is_reply == 1 && value.old_message ?
                    <div className="uix-quote">{value.old_message}</div>
                    : null}
                <p dir="auto" className="uix-text">{value.message}</p>
                {value.url_details != null && renderLinkCard(value.url_details, isMe)}
                {renderMeta(value, isMe)}
            </>
        );
    };

    const renderActions = (value, isMe) => (
        <div className="uix-msg-actions">
            <div className={`btn-group ${isMe ? 'dropstart' : 'dropend'}`}>
                <button type="button" className="uix-action-toggle" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Message actions">
                    <i className="fa-solid fa-ellipsis-vertical" />
                </button>
                <ul className="dropdown-menu">
                    <li>
                        <a className="dropdown-item clickable" onClick={() => replyMessage(value.id, value.message, value.sender?.name)}>
                            <i className="fa-solid fa-reply" /> Reply
                        </a>
                    </li>
                    {isMe &&
                        <li>
                            <a className="dropdown-item clickable text-danger" onClick={() => deleteMessageEveryOne(value.id)}>
                                <i className="fa-solid fa-trash-can" /> Delete for everyone
                            </a>
                        </li>
                    }
                    <li>
                        <a className="dropdown-item clickable text-danger" onClick={() => deleteMessage(value.id)}>
                            <i className="fa-solid fa-trash" /> Delete for me
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );

    return (
        <>
            {callStart &&
                <CallSendPopup onCancel={() => cancelCall()} image={user.avatar} name={user.name} />
            }

            <div className="uix-row">
                {/* Left: conversation list */}
                <aside className="uix-sidebar d-none d-md-flex">
                    <MessageNav />
                </aside>

                {/* Middle: chat window */}
                <main
                    className="uix-chat"
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                >
                    {dragActive &&
                        <div className="uix-drop-overlay">
                            <i className="fa-solid fa-cloud-arrow-up" />
                            Drop to send
                        </div>
                    }

                    {/* Header */}
                    <div className="uix-header">
                        <div className="uix-header-user">
                            <Link to="/messages" className="uix-icon-btn uix-back" aria-label="Back to messages">
                                <i className="fa-solid fa-arrow-left" />
                            </Link>
                            <div className="uix-avatar" style={{ background: `url(${user.avatar})` }}>
                                {user.is_online == 1 && <span className="uix-online-dot" />}
                            </div>
                            <div className="uix-header-info">
                                <h6 className="uix-header-name">
                                    <Link to={`/contact/${user.id}`} target="_blank">{user.name}</Link>
                                </h6>
                                <span className="uix-header-status">
                                    {partnerTyping
                                        ? <span className="uix-typing">typing<span className="uix-typing-dots" /></span>
                                        : (user.is_online == 1 ? 'Online' : user.last_seen1)}
                                </span>
                            </div>
                        </div>
                        <div className="uix-header-actions">
                            <button type="button" className="uix-icon-btn" title="Audio Call"
                                onClick={() => startCall(user.id, '0', user.name)}>
                                <i className="fa-solid fa-phone" />
                            </button>
                            <button type="button" className="uix-icon-btn" title="Video Call"
                                onClick={() => startCall(user.id, '1', user.name)}>
                                <i className="fa-solid fa-video" />
                            </button>
                            <button
                                type="button"
                                className="uix-icon-btn uix-muted"
                                onClick={() => setIsExpand(!isExpand)}
                                title="Details, media & files"
                                aria-expanded={!isExpand}
                            >
                                <i className="fa-solid fa-ellipsis-vertical" />
                            </button>
                        </div>
                    </div>

                    {/* Messages */}
                    <div className="uix-messages" ref={messagesBoxRef} onScroll={handleMessagesScroll} style={{ backgroundImage: `url(${ChatBg})` }}>
                        {has_page && loadingOlder.current &&
                            <div className="uix-loadmore" aria-live="polite">
                                <span className="uix-loadmore-spinner">
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                    Loading older messages…
                                </span>
                            </div>
                        }

                        {progress && (!chats || chats.length === 0) && demo_data.map((post, index) => (
                            <React.Fragment key={index}>
                                <div className="uix-skel-row">
                                    <ContentLoader speed={2} width={320} height={64} viewBox="0 0 320 64"
                                        backgroundColor="#e9ecf1" foregroundColor="#f4f6f9">
                                        <circle cx="24" cy="40" r="15" />
                                        <rect x="48" y="18" rx="10" ry="10" width="220" height="38" />
                                    </ContentLoader>
                                </div>
                                <div className="uix-skel-row uix-out">
                                    <ContentLoader speed={2} width={260} height={54} viewBox="0 0 260 54"
                                        backgroundColor="#dbe5f7" foregroundColor="#e8eefb">
                                        <rect x="30" y="8" rx="10" ry="10" width="220" height="38" />
                                    </ContentLoader>
                                </div>
                            </React.Fragment>
                        ))}

                        {!progress && chats && chats.length === 0 &&
                            <div className="uix-empty">
                                <i className="fa-regular fa-comments" />
                                No messages yet — say hello!
                            </div>
                        }

                        {chats?.map((value, index) => {
                            const isMe = selfId?.id === value.from_id;
                            const prev = chats[index - 1];
                            const grouped = prev && prev.from_id === value.from_id && prev.message_type != 13;
                            return (
                                <div
                                    key={value.id ?? `temp-${index}`}
                                    id={`message_id_${value.id}`}
                                    className={`uix-msg ${isMe ? 'uix-out' : ''} ${grouped ? 'uix-grouped' : ''} ${value.id && value.id === justConfirmedId.current ? 'uix-noanim' : ''}`}
                                >
                                    {!isMe &&
                                        <div
                                            className={`uix-msg-avatar ${grouped ? 'uix-spacer' : ''}`}
                                            style={{ background: `url(${value.sender?.avatar})` }}
                                        />
                                    }
                                    {isMe && renderActions(value, isMe)}
                                    <div className="uix-bubble">
                                        {renderBody(value, isMe)}
                                    </div>
                                    {!isMe && renderActions(value, isMe)}
                                </div>
                            );
                        })}

                        <div ref={messagesEndRef} />
                    </div>

                    {/* Reply preview bar */}
                    {reply_message_enable &&
                        <div className="uix-replybar">
                            <div className="uix-replybar-content">
                                <span className="uix-replybar-name">{reply_to || 'Reply'}</span>
                                <p className="uix-replybar-text">{reply_message}</p>
                            </div>
                            <button type="button" className="uix-replybar-close" onClick={replyMessageCancel} aria-label="Cancel reply">
                                <i className="fa-solid fa-xmark" />
                            </button>
                        </div>
                    }

                    {/* Composer */}
                    <div className="uix-composer">
                        <form onSubmit={handleSubmit}>
                            <div className="uix-composer-inner">
                                {recordingStatus ? (
                                    <div className="uix-recording">
                                        <span className="uix-rec-dot" />
                                        <span className="uix-rec-time">{formatTime(timer)}</span>
                                        <button type="button" className="uix-rec-cancel" title="Discard recording"
                                            onClick={() => finishRecording(true)}>
                                            <i className="fa-solid fa-trash" />
                                        </button>
                                        <button type="button" className="uix-send-btn" title="Send recording"
                                            onClick={() => finishRecording(false)}>
                                            <i className="fa-solid fa-paper-plane" />
                                        </button>
                                    </div>
                                ) : (
                                    <>
                                        <button type="button" className="uix-composer-btn" title="Attach photos & files"
                                            onClick={() => setPostShareModalDialog(true)}>
                                            <i className="fa-solid fa-paperclip" />
                                        </button>
                                        <textarea
                                            ref={textData}
                                            placeholder="Type a message..."
                                            value={text}
                                            onInput={handleInput}
                                            onKeyDown={handleKeyDown}
                                            onChange={() => { }}
                                            rows="1"
                                        />
                                        <button type="button" className="uix-composer-btn" title="Record voice message"
                                            onClick={startRecording}>
                                            <i className="fa-solid fa-microphone" />
                                        </button>
                                        <button type="submit" className="uix-send-btn" disabled={!text.trim()} title="Send">
                                            <i className="fa-solid fa-paper-plane" />
                                        </button>
                                    </>
                                )}
                            </div>
                        </form>
                    </div>
                </main>

                {/* Right: contact details & shared media */}
                {!isExpand &&
                    <aside className="uix-details">
                        <UserChatFile user={user} recentChatFile={chatHistory} self_data={self_data} />
                    </aside>
                }
            </div>

            <FileSend
                dargDrop={is_darg_drop}
                dargDropFile={darg_drop_file}
                isModalVisible={post_modalDialog}
                handleShowB={closeFileModal}
                to_id={id}
                childToParent={childToParent}
                is_group='0'
            />

            <ImageView
                images={image_array}
                isModalVisible={imageView_modalDialog}
                handleShowB={() => setImageViewModalDialog(false)}
                imageIndex={img_index}
            />
        </>
    );
};

export default UserInbox;
